import { createContext } from "react"
import { AppEventProviderContextValue } from "../types"

export const AppEventProviderContext = createContext<AppEventProviderContextValue>({
    events: [],
    gotoEvent: () => {},
    handleMarkAsRead: () => Promise.resolve(),
    handleMarkAllAsRead: () => Promise.resolve(),
    addEvent: () => Promise.resolve(),
})
